import { Inject, Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { CONF, Conf, RouterFacade, TileFacade, TileRouter } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class AgentDesktopRouter extends TileRouter {
  constructor(
    @Inject(CONF) protected override readonly conf: Conf,
    protected override readonly router: Router,
    protected override readonly routerFacade: RouterFacade,
    protected override readonly tileFacade: TileFacade
  ) {
    super(conf, router, routerFacade, tileFacade);
  }

  override navigateToTile(commands: any[], extras?: NavigationExtras): Promise<boolean>;
  override navigateToTile(extra?: NavigationExtras): Promise<boolean>;
  override navigateToTile(commandsOrExtra?: any, extras?: NavigationExtras): Promise<boolean> {
    const { commands, navExtras } = this.normalizeParams(commandsOrExtra, extras);
    return super.navigateToTile(['desktop', ...commands], navExtras);
  }
}
